import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../util/api";

export const fetchComponents = createAsyncThunk("components/fetchComponents", async pageName => {
    const response = await api.get(`v2/api/components/${pageName}`);
    return response.data;
});
export const fetchComponentsTypes = createAsyncThunk("components/fetchComponentsTypes", async () => {
    const response = await api.get(`v2/api/components/types`);
    return response.data;
});

export const editComponent = createAsyncThunk("component/edit", async ({key, value, id}) => {
    // const data = { [key]: value };
    // const response = await api.put(`v2/api/settings/components/${id}`, data);
    // return response.data;
    alert("editing this carousel!");
});

const initialState = {
    components: [],
    types: [],
    status: {
        type: "idle",
        error: null,
    },
    typesStatus: {
        type: "idle",
        error: null,
    },
};

const componentsSlice = createSlice({
    name: "components",
    initialState,
    reducers: {
        setInitialState: state => initialState,
    },
    extraReducers: {
        //get components:
        [fetchComponents.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [fetchComponents.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.components = action.payload.data;
        },
        [fetchComponents.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },

        //get types:
        [fetchComponentsTypes.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [fetchComponentsTypes.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.types = action.payload.data;
        },
        [fetchComponentsTypes.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },

        //edit component:
        // [editComponent.pending]: (state, action) => {
        //   state.status.type = "loading";
        // },
        // [editComponent.fulfilled]: (state, action) => {
        //   state.status.type = "succeeded";

        //   const components = state.components;
        //   const newComponents = components.map((comp) =>
        //     comp.id === action.payload.data.id ? action.payload.data : comp
        //   );
        //   state.components = newComponents;
        // },
        // [editComponent.rejected]: (state, action) => {
        //   state.status.type = "failed";
        //   state.status.error = action.error.message;
        // },
    },
});

export const {setInitialState} = componentsSlice.actions;
export default componentsSlice.reducer;

export const selectAllComponents = state => state.components.components;
export const selectComponentsStatus = state => state.components.status;
export const selectAllComponentsTypes = state => state.components.types;
